<template>
    <div>
        <h2 class="text-xl font-black md:text-2xl onlywow:md:text-4xl" v-text="t('general.reviews.title')" />

        <ReviewStars
            class="mt-2"
            :review-score="reviews.rating ?? undefined"
            :review-count="reviews.count"
            show-score
            show-rating
            show-count-as-label
        />

        <ul class="mt-4 grid grid-cols-1 gap-3 lg:grid-cols-3">
            <li
                v-for="(review, index) in reviews.reviews"
                :key="`${review.submitted_at}-${index}`"
                class="rounded-md border border-border/40 p-3 shadow-xs"
            >
                <div class="flex items-center justify-between gap-2">
                    <span class="text-sm font-bold" v-text="review.author ?? t('general.reviews.buyer')" />
                    <span class="text-xs text-zinc-600" v-text="formatDateShort(review.submitted_at)" />
                </div>
                <ReviewStars class="mt-1" :review-score="review.rating" size="sm" />
                <p v-if="review.title" class="mt-2 text-sm font-bold" v-text="review.title" />
                <p v-if="review.comment" class="mt-1 text-sm whitespace-pre-line" v-text="review.comment" />
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import ReviewStars from '@/components/reviews/ReviewStars.vue';
import { useDateFormatter } from '@/composables/useDateFormatter';
import type { TrustedShopsProductReviewsObject } from '@/types/generated';
import { useI18n } from 'vue-i18n';

defineProps<{
    reviews: TrustedShopsProductReviewsObject;
}>();

const { t } = useI18n();
const { formatDateShort } = useDateFormatter();
</script>
